<!-- SUPPORT PAGE -->
<section class="support">
  <div class="embed-container">
    <iframe
      [src]="supportUrl | safe : 'resourceUrl'"
      allowtransparency="true"
      frameborder="0"
      scrolling="no"
      allowfullscreen
      mozallowfullscreen
      webkitallowfullscreen
      oallowfullscreen
      msallowfullscreen
      appIframeTracker>
    </iframe>
  </div>
</section>
<!--END SUPPORT PAGE-->
